import Vue from 'vue'
import Router from 'vue-router'
// import Index from '@/components/index'
import FrameWork from '@/components/framework1'
import PicDetail from '@/components/picdetail'
import MapBox from '@/components/map1'
import Login from '@/components/login'
import Help from '../components/help'
import test from '../components/test'

Vue.use(Router)

const vueRouter = new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/test',
      component: test,
      meta: {showBack: true, showMenu: false,}
    },
    {
      path: '/',
      name: 'index',
      component: FrameWork,
      children: [{
        path: '/map',
        name: 'MapBox',
        component: MapBox,
        meta: {showBack: false, keepAlive: true, roadFlag: false,showMenu:true}
      }, {
        path: '/picDeatil',
        component: PicDetail,
        meta: {showBack: true, showMenu: false, roadFlag: false}
      }, {
        path: '/help',
        component: Help,
        meta: {showBack: true, showMenu: false,}
      }],
    }
  ]
})

vueRouter.beforeEach(function (to, from, next) {
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  next()
  const nextRoute = ['map', 'picDeatil', 'login', 'home'];
  //获取登录的token
  let token = localStorage.getItem("token");
  let path = to.path
  if(path==="/login"){
    next();
    return;
  }
  if(token){
    if(path==="/"){
      next({
        path:"/map"
      })
    }else {
      next()
    }
  }else {
    next({
      path:"/login"
    })
  }

  ///////////////////
  // let login = localStorage.getItem('islogin')
  // let path = to.path
  // if (path === '/login') {
  //   next()
  //   return
  // }
  // if (login == 1) {
  //   if (path === '/') {
  //     next({
  //       path: '/map'
  //     })
  //   } else {
  //     next()
  //   }
  // } else {
  //   next({
  //     path: '/login'
  //   })
  // }
});

export default vueRouter;




// WEBPACK FOOTER //
// ./src/router/index.js